import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { environment } from '../../../../environments/environment';
import { InstgramLogo } from '../../about/instgram-logo/instgram-logo';
import { CardStack } from '../../common/card-stack/card-stack';

@Component({
  selector: 'section[app-home-why]',
  imports: [MatIconModule, CardStack, InstgramLogo, InstgramLogo],
  templateUrl: './home-why.html',
  styleUrl: './home-why.scss',
})
export class HomeWhy {
  get address1(): string {
    return environment.address1;
  }
  get address2(): string {
    return environment.address2;
  }
}
